// Registry für Task 1.7 (Modul-Tab-Schließen = Settings-Reset, User-Entscheidung 2026-07-24):
// Muster gespiegelt von listInstanceFetchDispatch.ts. Jedes Modul registriert hier, wie seine
// transienten Default-Store-Einstellungen beim Schließen des Modul-Tabs (Workspace-Modus,
// KEIN `?list=`-Instanz-Tab) zurückgesetzt werden — kein Refetch, kein Router-Move, kein $reset/$dispose.

export type ModuleTabSettingsReset = () => void;

const resets = new Map<string, ModuleTabSettingsReset>();

export const registerModuleTabSettingsReset = (moduleRouteName: string, reset: ModuleTabSettingsReset): void => {
	resets.set(moduleRouteName, reset);
};

export const getModuleTabSettingsReset = (moduleRouteName: string): ModuleTabSettingsReset | undefined =>
	resets.get(moduleRouteName);
